import "@strust/ui/fonts.css";
import "./app/index.css";
import "@strust/ui/map.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app.tsx";
import { installStaleChunkRecovery } from "./shared/stale-chunk.ts";

// A tab opened before a deploy reloads once when a code-split chunk of its build is gone.
installStaleChunkRecovery(window);

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
